<template>
  <div class="instructors">
    <div class="instructors__head-instructor">
      <div
        class="instructors__instructor"
        @click="$emit('search-presenter', instructors[0].name)"
      >
        <img
          class="instructors__head-instructor-img"
          :src="$getInstructorImg(instructors[0].profile_img_url)"
          :alt="`INE Instructor ${instructors[0].name}`"
        />
        <p itemprop="author" class="instructors__head-instructor-name data">
          {{ instructors[0].name }}
        </p>
        <p class="instructors__head-instructor-primary lead">Primary</p>
      </div>
    </div>
    <div class="instructors__sub-instructors">
      <div
        @click="$emit('search-presenter', instructor.name)"
        v-for="instructor in instructors.slice(1, 100)"
        :key="instructor.name"
        class="instructors__instructor"
      >
        <img
          class="instructors__instructor-img"
          :src="$getInstructorImg(instructor.profile_img_url)"
          :alt="`INE Instructor ${instructor.name}`"
          v-tooltip="{
            content: instructor.name,
            placement: 'bottom-center',
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Instructors',
  props: {
    instructors: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.instructors {
  display: flex;
  margin: 5px 0 0 0;
  &__instructor {
    cursor: pointer;
    margin: 0 5px 0 0;
    &:hover {
      opacity: 0.5;
    }
  }
  &__head-instructor {
    margin: 0 10px 0 0;
    width: 100px;
  }
  &__head-instructor-img {
    border-radius: 100%;
    border: 1px solid var(--orange);
    width: 100px;
  }
  &__head-instructor-name {
    padding: 5px 0;
    text-align: center;
  }
  &__head-instructor-primary {
    font-size: 0.8rem;
    margin: 0;
    text-align: center;
  }
  &__instructor-img {
    border-radius: 100%;
    width: 75px;
  }
  &__sub-instructors {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
